module.exports = __webpack_public_path__ + "static/media/inbox.a5e399b5.svg";